import { render, staticRenderFns } from "./FormBuilderLeakPhotoForm.vue?vue&type=template&id=4208ac4d&"
import script from "./FormBuilderLeakPhotoForm.vue?vue&type=script&lang=js&"
export * from "./FormBuilderLeakPhotoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports